<div>
    <div id="context"  (click)="warnUser()">...</div>
</div>
